import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonSize, ButtonState, ButtonType, IApplication, IJobOffer } from '../../../../../../assets/types/dtoTypes';
import { SharedModule } from '../../../../../shared/shared.module';
import { JobsDetailsService } from '../../jobs-details/jobs-details.service';
import { Router } from '@angular/router';
import { JobPageService } from '../jobs-page.service';
import { PATH } from '../../../../../../assets/constants';
import { ImageService } from '../../../../../shared/services/image.service';
import {ButtonComponent} from "../../../../../shared/button/button.component";

@Component( {
    selector: 'app-job',
  imports: [
    TranslateModule,
    SharedModule,
    ButtonComponent,
  ],
    templateUrl: './job.component.html',
    standalone: true,
    styleUrl: './job.component.scss'
} )
export class JobComponent implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  private imageService = inject(ImageService);
  private router = inject(Router);
  private jobDetailsService = inject(JobsDetailsService);
  private jobService = inject(JobPageService);


  @Input() job: IJobOffer;

  applications: IApplication[];

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonState = ButtonState;

  protected readonly ButtonType = ButtonType;

  constructor() {
  }

  ngOnInit() {
    if ( this.job ) {
      this.jobDetailsService.getAllApplications( this.job.id ).subscribe( applications => {
        const imageUpdateTasks = applications.map( app =>
          this.imageService.appendSasTokenToProfileImageUrl( app.applicantProfileImageUrl, app.userId )
            .toPromise()
            .then( url => {
              app.applicantProfileImageUrl = url;
              return app;
            } ),
        );

        Promise.all( imageUpdateTasks ).then( updatedApps => {
          this.applications = updatedApps;
          this.cdr.detectChanges();
        } );
      } );
    }
  }

  deleteJobOffer() {
    this.jobService.deleteJobOffer( this.job.id ).subscribe( () =>
      this.router.navigate( [ `${PATH.COMPANY_DASHBOARD}/${this.job.companyId}` ] ),
    );
  }

  editJobOffer() {
    this.router.navigate(
      [ `/create-job-offer/${this.job.companyId}` ],
      {
        queryParams: {
          edit: true,
          jobId: this.job.id,
        },
      },
    );

  }
}
